export default __webpack_public_path__ + "faa3343d7012c35653d38f879ade0d67.png";